// extracted by mini-css-extract-plugin
module.exports = {"columns":"Columns_columns__Ki5vO","collapse":"Columns_collapse__Wx87i"};